import Vue from "vue";
import VueRouter from "vue-router";

import layout from "@/layout/levelLayout";
import store from "@/store";

// 解决路由重复跳转报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
    component: () => import("@/layout/community"),
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          active: "/home",
          requireAuth: false
        },
        component: () => import("@/views/community/home")
      },
      {
        path: "/problem",
        meta: {
          active: "/problem",
          requireAuth: false
        },
        component: () => import("@/views/problem")
      },
      {
        path: "/problem/:id",
        meta: {
          active: "/problem",
          requireAuth: false
        },
        component: () => import("@/views/problem/detail.vue")
      },
      {
        path: "/login",
        name: "login",
        meta: {
          active: "/login",
          requireAuth: false
        },
        component: () => import("@/views/community/login")
      }
    ]
  },
  {
    path: "/h",
    name: "h",
    meta: {
      requireAuth: true
    },
    redirect: "/dashboard",
    component: () => import("@/layout/index"),
    children: [
      {
        path: "/dashboard",
        meta: {
          active: "/dashboard",
          requireAuth: true
        },
        component: () => import("@/views/dashboard")
      },
      {
        path: "/curriculumCenter",
        meta: {
          active: "/curriculumCenter",
          requireAuth: "www:GET:/#/curriculumCenter"
        },
        redirect: "/curriculumCenter/3",
        component: () => import("@/views/curriculumCenter"),
        children: [
          {
            path: ":type",
            name: "curriculumCenter",
            meta: {
              active: "/curriculumCenter",
              requireAuth: "www:GET:/#/curriculumCenter"
            },
            component: () => import("@/views/curriculumCenter/packageList")
          },
          {
            path: ":type/:package",
            name: "package",
            meta: {
              active: "/curriculumCenter",
              requireAuth: "www:GET:/#/curriculumCenter"
            },
            component: () => import("@/views/curriculumCenter/courseList")
          }
        ]
      },
      {
        path: "/oj",
        meta: {
          active: "/oj",
          requireAuth: 'api:GET:/manage/problem/list'
        },
        component: () => import("@/views/oj/problem")
      },
      {
        path: "/oj/add",
        meta: {
          active: "/oj/add",
          requireAuth: "api:POST:/manage/problem/add"
        },
        component: () => import("@/views/oj/problem-edit")
      },
      {
        path: "/oj/edit",
        meta: {
          active: "/oj",
          requireAuth: "api:POST:/manage/problem/edite"
        },
        component: () => import("@/views/oj/problem-edit")
      },
      {
        path: "/myWork",
        meta: {
          active: "/myWork",
          requireAuth: "www:GET:/#/myWork"
        },
        component: () => import("@/views/myWork")
      },
      {
        path: "/class",
        meta: {
          active: "/classManage",
          requireAuth: "www:GET:/#/classManage"
        },
        redirect: "/classManage",
        component: layout,
        children: [
          {
            path: "/classManage",
            name: "classManage",
            meta: {
              active: "/classManage",
              requireAuth: "www:GET:/#/classManage"
            },
            component: () => import("@/views/classManage")
          },
          {
            path: "/classManage/:id",
            name: "classDetails",
            meta: {
              active: "/classManage",
              requireAuth: "www:GET:/#/classManage"
            },
            component: () => import("@/views/classManage/classDetails")
          }
        ]
      },
      {
        path: "/stuManage",
        meta: {
          active: "/stuManage",
          requireAuth: "www:GET:/#/stuManage"
        },
        component: () => import("@/views/stuManage")
      },
      {
        path: "/workerManage",
        meta: {
          active: "/workerManage",
          requireAuth: "www:GET:/#/workerManage"
        },
        component: () => import("@/views/workerManage")
      },
      {
        path: "/powerManage",
        meta: {
          active: "/powerManage",
          requireAuth: "www:GET:/#/powerManage"
        },
        component: () => import("@/views/powerManage")
      },
      {
        path: "/courseList",
        meta: {
          active: "/courseList",
          // requireAuth: "www:GET:/#/courseList"
        },
        component: () => import("@/views/courseList")
      },
      {
        path: "/courseList/courseDetail",
        name: 'courseDetail',
        meta: {
          active: "/courseList",
          // requireAuth: "www:GET:/#/courseList"
        },
        component: () => import("@/views/courseList/courseDetail")
      },
      {
        path: "/timetable",
        meta: {
          active: "/timetable",
          requireAuth: "www:GET:/#/timetable"
        },
        component: () => import("@/views/timetable")
      },
      {
        path: "/InstitutionAudit",
        meta: {
          active: "/InstitutionAudit",
          requireAuth: "www:GET:/#/InstitutionAudit"
        },
        component: () => import("@/views/InstitutionAudit")
      }
    ]
  },
  {
    path: "/ppt",
    meta: {
      requireAuth: true
    },
    component: () => import("@/components/ppt")
  },
  {
    path: "/python",
    meta: {
      requireAuth: false
    },
    component: () => import("@/views/py")
  },
  {
    path: "/t68790",
    meta: {
      requireAuth: true
    },
    component: () => import("@/components/test")
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  // base: process.env.BASE_URL,
  routes
});

export default router;

// 当路由改变时
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem("dclass_token")
  if (token && !store.state.userInfo.userid) {
    await store.dispatch('getUserInfo')
  }

  if (
    to.meta.requireAuth ||
    store.state.userRole.includes(to.meta.requireAuth)
  ) {
    // 判断该路由是否需要登录权限
    if (localStorage.getItem("dclass_token")) {
      if(from.query.redirect) {
        next({ path: decodeURIComponent(from.query.redirect) });
      } else {
        next();
      }
    } else {
      next({
        path: "/login",
        query: { redirect: to.fullPath }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    next();
  }
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
